import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AccountSettingsNavComponent } from './account-settings-nav.component';

@Component({
  selector: 'app-account-settings-layout',
  standalone: true,
  imports: [RouterOutlet, AccountSettingsNavComponent],
  templateUrl: './account-settings-layout.component.html',
  styleUrls: ['./account-settings-layout.component.scss']
})
export class AccountSettingsLayoutComponent {}
